import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
import Chatbot from "./Components/Chatbot";
import WebStore from "./Components/Web-store";
import WebsiteDevelopment from "./Components/Website_Development";
import ApplicationDevelopment from "./Components/Application_Development";
import Ecommerce from "./Components/Ecommerce";
import DigitalMarketing from "./Components/DigitalMarketing";
import GoogleAds from "./Components/Google_ads";
import MetaAds from "./Components/Meta_ads";
import EcommercePricing from "./Components/EcommercePricing";
import VendorPricing from "./Components/VendorPricing";
import OTTPlatformPricing from "./Components/OTTPlatformPricing";
import CRMPricing from "./Components/CRMPricing";
import StaffPricing from "./Components/StaffPricing";
import LoginPricing from "./Components/LoginPricing";
import About from "./Components/About";
import Contact from "./Components/Contact";
import WhatsAppLink from "./Components/Whatsapp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import toastify CSS
import ScrollToTop from "./Components/ScrollToTop";
import InquiryForm from "./Components/EnquiryForm";
import ProfileComponent from "./Components/Profile";
import MultiStepForm from "./Components/AdmissionForm";
import Login from "./Components/Login";
import Register from "./Components/Register";
import GetWebsiteThripleNine from "./Components/GetWebsiteThripleNine";
import axios from "axios";
import ForgotPassword from "./Components/Forgot";
import Gallery from "./Components/Gallery";
import GalleryDeep from "./Components/GalleryDeep";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import RefundPolicy from "./Components/RefundPolicy";
import TermsAndConditions from "./Components/TermsAndConditions";
import Cart from "./Components/Cart";
import Checkout from "./Components/Checkout";
import { use } from "react";
import PaymentSuccess from "./Components/Paymentsuccess";
import PaymentFailed from "./Components/PaymentFailed";
import PrivateRoute from "./Components/PrivateRoute";
import NewHeader from "./Components/NewHeader";
import NewRegister from "./Components/NewRegister";
import WebsiteDevelopService from "./Components/WebsiteDevelopServices";
import Blog from "./Components/Blog/Blog";
import BlogDetail from "./Components/Blog/BlogDetail";
import AllCommentsPage from "./Components/Blog/AllCommentPage";

import QuotationResponsePage from "./Components/quotation/QuotationResponsePage";
import ThankYou from "./Components/quotation/ThankYou";
import OwnerShip from "./Components/Ownership";


const getAccessToken = async () => {
  let accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  try {
    // If accessToken is expired, refresh it
    if (!accessToken) {
      const response = await axios.post(
        "https://yourapi.com/api/refresh-token",
        { refreshToken }
      );
      accessToken = response.data.accessToken;
      localStorage.setItem("accessToken", accessToken);
    }
  } catch (error) {
    console.error("Session expired. Please log in again.");
    localStorage.clear();
    window.location.href = "/login"; // Redirect to login if refresh fails
  }

  return accessToken;
};

// Axios interceptor to refresh token automatically
axios.interceptors.response.use(
  (response) => response, // Return response if it's successful
  async (error) => {
    if (error.response.status === 401) {
      const accessToken = await getAccessToken();
      error.config.headers["Authorization"] = `Bearer ${accessToken}`;
      return axios(error.config); // Retry the request with the new token
    }
    return Promise.reject(error);
  }
);

const App = () => {
  const [cartItems, setCartItems] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [triggerClick, setTriggerClick] = useState(false);
  const [showCartButton, setShowCartButton] = useState(false);
  const location = useLocation();
  const login = JSON.parse(localStorage.getItem("login")) || false;

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable text selection
    const handleSelectStart = (e) => e.preventDefault();
    document.addEventListener("selectstart", handleSelectStart);

    // Disable copy (Ctrl+C)
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === "c" || e.key === "C")) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("selectstart", handleSelectStart);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  const fetchCartData = async () => {
    try {
      const response = await fetch(
        `https://100billionrealestate.com/cart/getcartadded/${login.emplyee_ID}`
      );
      const data = await response.json();
      // const activeItems = data.filter(item => item.status === "Active");
      const total = data.reduce(
        (acc, item) => acc + Number(item.product_price),
        0
      );
      console.log(total);
      setTotalAmount(total);
      setCartItems(data);
      if (data.length > 0) {
        setShowCartButton(true);
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  // const addToCart = (benefit) => {
  //   setCartItems((prevItems) => {
  //     const isAlreadyAdded = prevItems.some(
  //       (item) => item.title === benefit.title
  //     );

  //     if (isAlreadyAdded) {
  //       toast.error(`${benefit.title} is already added`);
  //       return prevItems;
  //     }

  //     const updatedCart = [...prevItems, benefit];

  //     setTotalAmount((prevTotal) => prevTotal + Number(benefit.sale_price));

  //     setTriggerClick(true);
  //     setTimeout(() => setTriggerClick(false), 100);

  //     return updatedCart;
  //   });

  //   setShowCartButton(true);
  // };

  useEffect(() => {
    if (login && login.emplyee_ID) {
      fetchCartData();
    }
  }, []);

  return (
    <>
      <NewHeader cartItems={cartItems} fetchCartDataMainPage={fetchCartData} />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/enquiry" element={<InquiryForm />} />
        <Route path="/website-development" element={<WebsiteDevelopment />} />
        <Route
          path="/application-development"
          element={<ApplicationDevelopment />}
        />
        <Route path="/digital-marketing" element={<DigitalMarketing />} />
        <Route path="/get-your-online-store" element={<Ecommerce />} />
        <Route path="/meta-ads" element={<MetaAds />} />
        <Route path="/Google-ads" element={<GoogleAds />} />
        <Route path="/web-Store" element={<WebStore />} />
        <Route path="/ecommerce-price" element={<EcommercePricing />} />
        <Route path="/vendor-price" element={<VendorPricing />} />
        <Route path="/ottplatform-price" element={<OTTPlatformPricing />} />
        <Route path="/crm-price" element={<CRMPricing />} />
        <Route path="/staff-price" element={<StaffPricing />} />
        <Route path="/login-price" element={<LoginPricing />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/profile" element={<ProfileComponent />} />
        <Route path="/ownership" element={<OwnerShip />} />
        <Route path="/service-plan" element={<MultiStepForm />} />
        {/* <Route path="/product-page/:id" element={<SingleProductPage />} />
        <Route path="/equipment" element={<Products />} /> */}
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/start-growing-your-business-at-₹1999/Month"
          element={
            <GetWebsiteThripleNine
              // addToCart={addToCart}
              fetchCartData={fetchCartData}
              totalAmount={totalAmount}
              triggerClick={triggerClick}
              setTriggerClick={setTriggerClick}
              showCartButton={showCartButton}
              cartItems={cartItems}
            />
          }
        />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/event-gallery/:id" element={<GalleryDeep />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/new-register" element={<NewRegister />} />
        <Route
          path="/real-estate-website-development-service"
          element={<WebsiteDevelopService />}
        />
               <Route path="/" element={<Blog />} />
<Route path="/blog" element={<Blog />} />

<Route path="/blogs/:slug" element={<BlogDetail />} />
<Route path="/blogs/:slug/comments" element={<AllCommentsPage />} />

        <Route
          path="/cart"
          element={
            <PrivateRoute>
              {" "}
              <Cart fetchCartDataMainPage={fetchCartData} />{" "}
            </PrivateRoute>
          }
        />
{/* <Route
  path="/thank-you"
  element={
    <PrivateRoute>
      <ThankYou />
    </PrivateRoute>
  }
/> */}

<Route
  path="/quotation-response/:quotationId"
  element={<QuotationResponsePage />}
/>



        <Route
          path="/checkout"
          element={
            <PrivateRoute>
              <Checkout />
            </PrivateRoute>
          }
        />
        <Route
          path="/success/:id"
          element={
            <PrivateRoute>
              <PaymentSuccess />
            </PrivateRoute>
          }
        />
        <Route
          path="/failure/:id"
          element={
            <PrivateRoute>
              <PaymentFailed />
            </PrivateRoute>
          }
        />
      </Routes>
      <Footer />
      {location.pathname !== "/cart" && (
        <>
          <Chatbot />
          <WhatsAppLink />
        </>
      )}
      <ToastContainer />
    </>
  );
};

export default App;
